export const setitem = (l10n={}, it = {}) => {
    if (!it.setItem) return '';

    let optionList = it.setItem.optionGroupList?.map( op => {
        return `
        <li>
            <div class="key">${l10n['item.nSetEffect'].replace('{n}', op.completionDegree)}</div>
            <div class="value">
                ${op.optionList.map( ol => `<p>${ol.displayValue}</p>`).join('')}
            </div>
        </li>`;
    }).join('');

    return `
    <section class="set">
        <header>
            <h3>${l10n['item.setEffect']}</h3>
            <button class="btn-folder is-active"></button>
        </header>
        <article class="is-active">
            <ul>
                ${optionList}
                <li>
                    <div class="key">${l10n['item.setItem']}</div>
                    <div class="value">
                        ${it.setItem?.itemList?.map(sit=>`
                        <p>
                            <button data-detailshow="item_${sit.id}" data-id="${sit.id}" data-itemgrade="${sit.gradeId}">
                                ${sit.name}
                                ${sit.tradable? ``: `<span class="tradable" title="${l10n['item.bound']}"></span>`}
                            </button>
                        </p>
                        `).join('')}
                    </div>
                </li>
            </ul>
        </article>
    </section>`;
}
